import { useEffect, useMemo } from 'react';
import { useInfiniteQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { practicalInformationApi } from 'src/Services/API';

const PRACTICAL_INFORMATION_PER_PAGE = 10;

const useFetchAllPracticalInformation = () => {
  const assetId = useCurrentAssetId();

  const query = useInfiniteQuery({
    queryKey: ['fetch-all-practical-information', assetId],
    queryFn: async ({ pageParam = 1 }) => {
      if (!assetId) throw new Error('No assetId provided');

      return (
        await practicalInformationApi.practicalInformationControllerFindAll(
          assetId,
          pageParam,
          PRACTICAL_INFORMATION_PER_PAGE,
          'createdAt'
        )
      ).data;
    },
    getNextPageParam: lastPage => {
      if (!lastPage) return undefined;
      return lastPage.currentPage < lastPage.pageCount ? lastPage.currentPage + 1 : undefined;
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });

  useEffect(() => {
    const loadAllPages = async () => {
      if (query.hasNextPage && !query.isFetchingNextPage) {
        await query.fetchNextPage();
      }
    };

    loadAllPages();
  }, [query.hasNextPage, query.isFetchingNextPage, query.fetchNextPage]);

  const allInstructions = useMemo(
    () => query.data?.pages.flatMap(page => page?.items ?? []) ?? [],
    [query.data]
  );

  return {
    data: allInstructions,
    isLoading: query.isLoading || query.isFetchingNextPage,
    error: query.error,
  };
};
export default useFetchAllPracticalInformation;
